module.exports = __webpack_public_path__ + "img/Banner-company-verification-analysis.89fdc982.png";